import { createPaginationEntity, request } from '@luna/api';
import { getEnv } from '@luna/env';

import type { Card, PagedListResponse } from './types/aggregationService';
import { mapCardWithCustomizationFallback } from './entityService';

const DEFAULT_PAGE_SIZE = 50;

export const {
    useEntity: useCard,
    useEntities: useCards,
    entityHelpers: cardsEntityHelpers,
} = createPaginationEntity({
    name: '@products/aggregation/cards',
    payloadCreators: {
        queryById: (id) =>
            request<Card>(`${getEnv().apiGatewayUrl}product/public/cards/${id}`).then(
                mapCardWithCustomizationFallback,
            ),
        queryPage: async ({ pageNumber = 0, pageSize = DEFAULT_PAGE_SIZE } = {}) => {
            const response = await request<PagedListResponse<Card>>(
                `${getEnv().apiGatewayUrl}product/public/cards?page=${pageNumber}&size=${pageSize}`,
            );

            return {
                data: response.items.map(mapCardWithCustomizationFallback),
                pageNumber: response.page.number,
                pageCount: response.page.totalPages,
                pageSize: response.page.size,
                totalElements: response.page.totalElements,
            };
        },
    },
});
